import { onMounted, onUnmounted } from 'vue'
import { ElNotification } from 'element-plus'

const INTERVAL_MS = 10 * 60 * 1000

function extractFingerprint(html) {
  // Collect all script src hashes injected by webpack (e.g. app.a1b2c3d4.js)
  const matches = html.match(/src="[^"]*\.([a-f0-9]{8,})\.(js|css)"/g) || []
  return matches.sort().join('|')
}

async function fetchFingerprint() {
  const res = await fetch('/index.html?_=' + Date.now(), { cache: 'no-store' })
  const html = await res.text()
  return extractFingerprint(html)
}

export function useVersionCheck(t) {
  let initialFingerprint = null
  let timer = null
  let notified = false

  async function check() {
    try {
      const fingerprint = await fetchFingerprint()
      if (!initialFingerprint) {
        initialFingerprint = fingerprint
        return
      }
      if (!notified && fingerprint !== initialFingerprint) {
        notified = true
        ElNotification({
          title: t('General.VersionCheck.Title'),
          message: t('General.VersionCheck.Message'),
          type: 'warning',
          duration: 0,
          showClose: true,
          position: 'bottom-left',
          onClick() {
            window.location.reload()
          },
        })
      }
    } catch {
      // network error — skip silently, try again next tick
    }
  }

  onMounted(async () => {
    await check()
    timer = setInterval(check, INTERVAL_MS)
  })

  onUnmounted(() => {
    clearInterval(timer)
  })
}
